<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="home"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>搜索</span></p></div>
          </div>

        </div>
        <div class="wraper">
          <div class="policy_search_part">
            <div class="policy_search">
              <input name="" v-model="condition" type="text" placeholder="搜索你想了解的政策/资讯/服务" style="width: 570px;font-size:14px;">
              <button  style="width: 77px;"  @click="butten"></button>
            </div>
            <p></p>
            <p></p><p></p>
          </div>
          <div class="clear"></div>
          <div class="aaa" style="width: 100%">
          <el-tabs v-model="activeName" >
            <el-tab-pane :label="'政策文件'+'('+pageTotal3+')'" name="second" >
              <div class="policy_right2">
                <ul v-if="zcList.length!=0" style="padding-top: 0px;">
                  <li  v-for="(item,index) in zcList" :key="item.data_id" >

                    <a  href="javascript:void(0)" @click="seeShare('PolicyDetail',{detail_id:item.data_id})"  style="width: 90%;">
                      <dt style="height: 90px"><h3><img src="../../../static/images/policy_sign6.png"></h3><p>{{item.policy_date}}</p></dt>
                      <dd style="height: 90px;padding-top: 10px;">
                        <div style="height: 24px;line-height: 20px;font-size: 12px;border-bottom: 1px solid #d7d6d6;"><span style="font-weight: 600">文号：</span>{{item.policy_number}}&nbsp; &nbsp;<span style="font-weight: 600;margin-left: 50px;">发布单位：</span>{{item.party_name}}</div>
                        <h4 style="margin-top: 10px;">{{item.title}} </h4>
                        <div style="width:710px;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.policy_abstract}}</div>
                      </dd>
                    </a>
                  </li>
                </ul>
                <div class="clear"></div>
              </div>
              <div class="page" style="width: 80%" v-if="zcList.length>0">     <el-pagination
                layout="prev, pager, next"
                :total="pageTotal3" :page-size="pageSize3" @current-change="pageChange3" @prev-click="prevClick3" @next-click="nextClieck3">
              </el-pagination>
              </div>

              <div v-if="zcList.length==0">
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="'监督咨询'+'('+pageTotal+')'" name="third">
              <div class="policy_right2" v-if="pageTotal!=0">
                <ul style="padding-top: 0px;">
                  <li  v-for="(item,index) in jdList" :key="item.id"  >
                <!--    <a href="javascript:void(0)" @click="seeShare('suggestDetail',{detail_id:item.id})"    style="width: 90%;">
                      &lt;!&ndash;style="padding-bottom: 0px;padding-top: 0px;padding-left: 0px"&ndash;&gt;
                      <dt ><h3 style="margin-top: 10px;">{{item.day}}</h3><p >{{item.time}}</p> </dt>
                      <dd>
                        <h3>{{item.title}} <span style="float: right" >
                     &lt;!&ndash; <el-tag v-if="item.es_status!='2'"
                              type="danger"
                              effect="dark" style="width: 60px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size:10px;text-align: center">
                    待处理
                  </el-tag>
                       <el-tag  v-if="item.es_status=='2'"
                                effect="dark" style="width: 60px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size:10px;text-align: center">
                    已回复
                  </el-tag>&ndash;&gt;
                    </span ></h3>
                        <p style="font-size: 14px;margin-top: 10px;">{{item.sReamrk| ellipsis}}</p>
                      </dd>
                    </a>
              -->      <a  href="javascript:void(0)" @click="seeShare('suggestDetail',{detail_id:item.id})" style="width: 90%;">
                      <dt style="height: 90px"><h3><img src="../../../static/images/policy_sign6.png"></h3><p>{{item.time}}</p></dt>
                      <dd style="height: 90px;padding-top: 10px;">
                        <h4 style="margin-top: 10px;">{{item.title| ellipsisTitle}} </h4>
                        <div style="width:710px;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.sReamrk| ellipsis}}</div>
                      </dd>
                    </a>
                  </li>
                </ul>
                <div class="clear"></div>
              </div>
              <div v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
              <div class="page" v-if="pageTotal!=0">
                <el-pagination
                  layout="prev, pager, next"
                  :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="'通知公告'+'('+pageTotal2+')'" name="first">
              <div class="notice_con" v-if="pageTotal2!=0">
                <ul style="padding-top: 0px;">
                  <li  v-for="(item,index) in ggtzList" :key="index" >
                    <a href="javascript:void(0)" @click="seeShare('NoticeDetail',{detail_id:item.id})"    style="width: 90%"  >
                      <dt style=" white-space:nowrap;line-height: 70px"><h3>{{item.day}}</h3><p>{{item.yearMonth}}</p></dt>
                      <dd>
                        <h4>{{item.title| ellipsisTitle}} <span style="float: right;font-size:14px">发布单位：{{item.data_author}}</span></h4>
                        <p>{{item.remark}}</p>
                      </dd>
                    </a>
                  </li>
                </ul>
                <div class="clear"></div>
              </div>
              <div class="notice_con" v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
              <div class="page" style="width: 100%" v-if="pageTotal2!=0">     <el-pagination
                layout="prev, pager, next"
                :total="pageTotal2" :page-size="pageSize2" @current-change="pageChange2" @prev-click="prevClick2" @next-click="nextClieck2">
              </el-pagination>
              </div>
            </el-tab-pane>

          </el-tabs>
          </div>
        </div>

      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  export default {
    name: "public-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      return {
        pageNum:1,
        pageSize:6,
        pageNum2:1,
        pageSize2:6,
        pageNum3:1,
        pageSize3:6,
        pageTotal:0,
        pageTotal2:0,
        pageTotal3:0,
        condition:'',
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        activeName: 'first',
        ggtzList:[],
        jdList:[],
        zcList:[],
      }
    } ,
    watch: {

    },
    filters: {
      ellipsis (value) {
        if (!value) return ''
        if (value.length > 120) {
          return value.slice(0,120) + '...'
        }
        return value
      },
      ellipsisTitle (value) {
        if (!value) return ''
        if (value.length > 39) {
          return value.slice(0,39) + '...'
        }
        return value
      }

    },

    mounted(){
      // this.initNews('zcwj');

    },
    created(){
      this.condition=this.$route.query.condition;
      this.initAllData();
    },
    methods: {
      seeShare(url,d){
        let routeUrl = this.$router.resolve({
          path: "/"+url,
          query: d
        });
        window.open(routeUrl.href, '_blank');
      },
      initAllData(){
        this.pageNum=1;
        this.pageNum2=1;
        this.pageNum3=1;
        this.ggtzList=[];
          this.jdList=[];
          this.zcList=[];
        this.initData();
        this.initData_new();
        this.initData_zc();
      },
      gotoDetail(detail_id){
        this.$router.push({path:'PolicyDetail',query:{detail_id:detail_id}})
      },
      butten(){
        this.initAllData();
      },
      prevClick3(a){
        this.pageNum3=this.pageNum3-1;
        this.initData_zc();
      },
      nextClieck3(a){
        this.pageNum3=this.pageNum3+1;
        this.initData_zc();
      },
      pageChange3(a){
        this.pageNum3=a
        this.initData_zc();
      },
      prevClick2(a){
        this.pageNum2=this.pageNum2-1;
        this.initData_new();
      },
      nextClieck2(a){
        this.pageNum2=this.pageNum2+1;
        this.initData_new();
      },
      pageChange2(a){
        this.pageNum2=a
        this.initData_new();
      },
      prevClick(a){
        this.pageNum=this.pageNum-1;
        this.initData();
      },
      nextClieck(a){
        this.pageNum=this.pageNum+1;
        this.initData();
      },
      pageChange(a){
        this.pageNum=a
        this.initData();
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      initData_new(){
        /*查询新闻*/
        var tt=this;
        const options2={pageSize:this.pageSize2,pageNum:this.pageNum2,condition:this.condition}
        this.$https.post("api/pu/info/listTzggListLimit.do",options2,response=> {
          if (response.status === 200 && response.data.code === 200) {
            if(response.data.data.list && response.data.data.list.length>0){
              this.ggtzList=response.data.data.list;
            }
            if (response.data.data.total!=undefined){
              tt.pageTotal2= response.data.data.total;
            }else {
              tt.pageTotal2=0;
            }
          }
        });
      },
      initData(){
        var t=this;
        /*查询监督*/
        const options={pageSize:this.pageSize,pageNum:this.pageNum,condition:this.condition}
        this.$https.post("api/suggest/getSuggestAll.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data.all && response.data.data.all.length>0){
              t.jdList=response.data.data.all;

            }
            t.pageTotal=parseInt(response.data.data.all[0].total);
          } else {
            // t.departOption =[];
          }
        });


      },
      initData_zc(){
        var t=this;
        const options={pageSize:this.pageSize3,pageNum:this.pageNum3,searchTitle:this.condition}
        this.$https.post("api/policy/getPolicyList.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data.listData &&response.data.data.listData.length>0){
              t.zcList=response.data.data.listData;
            }
            t.pageTotal3=response.data.data.total;
          } else {
            // t.departOption =[];
          }
        })
      },
    }
  }



</script>

<style>
  .aaa .el-tabs__item{
    padding: 0 20px;
    height: 60px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 60px;
    display: inline-block;
    list-style: none;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/pages/search/UserSearch.vue